export default function ContactInfo() {
  return (
    <section className="py-16 px-4 bg-amber-50">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* 聯絡我們 */}
          <div className="text-center">
            <h2 className="text-xl font-bold text-gray-900 mb-3">聯絡我們</h2>
            <p className="text-gray-700 mb-1">Lam Lam Wholesale</p>
            <p className="text-gray-700 mb-4">+852 9385 5368</p>
          </div>

          {/* 门市地址 */}
          <div className="text-center">
            <h2 className="text-xl font-bold text-gray-900 mb-3">門市地址：</h2>
            <p className="text-gray-700 mb-1">九龍觀塘偉業街221號</p>
            <p className="text-gray-700 mb-1">美德工業大廈D座10樓31室</p>
            <p className="text-gray-700">TEL: 9385 5368</p>
          </div>

          {/* 营業时间 */}
          <div className="text-center">
            <h2 className="text-xl font-bold text-gray-900 mb-3">門市營業時間：</h2>
            <p className="text-gray-700 mb-1">星期一至星期日及公眾假期</p>
            <p className="text-gray-700">12:00-20:30</p>
          </div>
        </div>
      </div>
    </section>
  );
}
